module.exports = __webpack_public_path__ + "img/close-circle.c0ffad52.svg";